import auth0 from "auth0-js";
import { AUTH0_CLIENT_SECRET, AUTH0_CLIENT_DOMAIN } from "src/constants";

export const auth0Cfg = {
  domain: AUTH0_CLIENT_DOMAIN,
  clientID: AUTH0_CLIENT_SECRET,
  redirectUri: `${window.location.origin}/sso/callback`,
  logoutRedirectUri: `${window.location.origin}/logout`,
  responseType: 'token'
}


export const auth0Client = new auth0.WebAuth(auth0Cfg);



